import styled from 'styled-components';

export const GeomapWidgetStyled = styled.div`
  display: grid;
  width: 100%;
  height: 100%;
`;
